export default "__VITE_PUBLIC_ASSET__272dab22__"